import { useQuery } from 'react-query';
import ElasticSearchFilterAPI from 'services/API/ElasticSearchFilterAPI';
import type {
  CompanyFilterParameters,
  CompanyFilterResponse,
} from '@mercator-gcp/types/elastic_search_service/CompanyFilter';

type Props = {
  companyNameQuery: CompanyFilterParameters['name_search'];
  projectCityCodes?: CompanyFilterParameters['project_city_codes'];
  companyTypes: CompanyFilterParameters['company_types'];
  page: number;
  sort?: string[];
};

export const useCompanySearch = ({
  companyNameQuery,
  projectCityCodes,
  companyTypes,
  page = 1,
  sort,
}: Props) => {
  const filteredCompanies = useQuery(
    ['filterCompanies', companyNameQuery, projectCityCodes, companyTypes, page, sort],
    async (): Promise<CompanyFilterResponse> => {
      const result = await ElasticSearchFilterAPI.postFilterCompanies({
        name_search: companyNameQuery,
        project_city_codes: projectCityCodes,
        company_types: companyTypes,
        page,
        sort,
      });

      return result?.data;
    },
    {
      enabled: page > 0,
      refetchOnWindowFocus: false,
    },
  );

  return {
    filteredCompanies,
  };
};
